<esp-deposit-free-text [autoPopulated]="isAutoPopulated"
                       [freeText]="depositFormDataService.coverage"
                       placeholder="{{'research.coverage.text' | customTranslate}}">
</esp-deposit-free-text>
